import { BaseForm, loader } from '@titanio/forms'
import moneyValidation from '@titanio/validator/money'
import dateValidation from '@titanio/validator/date'
import tooltip from '@magnetita/tooltip'
import textfield from '@magnetita/textfield'
import quicklink from '@components/calculator/quicklink'
import { convertToDatetime } from '@modules/formatterDate'

export default class TerminationCalculator extends BaseForm {
  constructor() {
    super({ formElement: '[data-validate-termination]' })
  }

  mount() {
    textfield.mount()
    tooltip.mount()

    this.preloadNextStep()
  }

  onRequest(event) {
    event.preventDefault()

    /**
     * dateEnd Custom Validate
     */
    if (this.isDateStartLessThanDateEnd()) return

    /**
     * show loader and dynamic import seeder
     */
    loader({ context: this.form, status: 'pending' })
    import(
      /* webpackChunkName: "seeder" */
      '@components/calculator/seeder'
    ).then((module) => {
      const Seeder = module.default
      const seeder = new Seeder({ apiPath: 'clt-termination' })
      seeder.mount()

      loader({ context: this.form, status: 'loaded' })
    })
  }

  onValidate() {
    moneyValidation(this.validator)
    dateValidation(this.validator)
  }

  preloadNextStep() {
    const nextImage = document.querySelector('[data-seeder-preload="form"]')
    if (!nextImage) return

    this.preloaded = true
    quicklink.preload(nextImage)
  }

  isDateStartLessThanDateEnd() {
    const dateEnd = this.form.querySelector(`[name="adimissionDateEnd"]`)
    const dateStart = this.form.querySelector(`[name="adimissionDateStart"]`)

    const dateEndValue = convertToDatetime(dateEnd.value)
    const dateStartValue = convertToDatetime(dateStart.value)

    if (dateEndValue < dateStartValue) {
      this.validator.addError(
        dateEnd,
        'A Data de afastamento não pode ser menor que a Data de adimissão'
      )
    }

    return dateEndValue < dateStartValue
  }
}
